export const SUCCESS_MODAL_HEADER = "project.creation.success.modal.header";
export const SUCCESS_MODAL_BODY = "project.creation.success.modal.body";
export const SUCCESS_BUTTON_GO_TO_PROJECTS = "project.creation.success.button.go.to.projects";
export const SUCCESS_BUTTON_CONTINUE_HERE = "project.creation.success.button.continue.here";

export const ERROR_MODAL_HEADER = "project.creation.error.modal.header";
export const ERROR_MODAL_BODY = "project.creation.error.modal.body";
export const ERROR_BUTTON_CONTACT_SUPPORT = "project.creation.error.button.contact.support";
export const ERROR_BUTTON_TRY_AGAIN = "project.creation.error.button.try.again";
